import React, { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import SidePannel from "../../components/SidePannel";
import styles from "./styles";
import { SIDE_PANNEL_TEXT } from "../../utils/Constants";
import RightPannel from "../../components/RightPannel";
import AddGlucoseLevel from "../../../../Diathrive/src/containers/AddGlucoseLevel";
import { useDisableBodyScroll } from "../../../../Diathrive/src/hooks/use-disable-dody-scroll";

const Layout = () => {
  const [headerName, setHeaderName] = useState(SIDE_PANNEL_TEXT.HOME);
  const [openManualEntry, setOpenManualEntry] = useState(false);
  const [openMyProfile, setOpenMyProfile] = useState(false);
  const navigate = useNavigate();

  //hook to disable scrolling for web
  useDisableBodyScroll(openManualEntry);

  return (
    <div style={styles.container}>
      <div style={styles.sidebar}>
        <SidePannel
          setHeaderName={setHeaderName}
          setOpenManualEntry={setOpenManualEntry}
          setOpenMyProfile={setOpenMyProfile}
          openMyProfile={openMyProfile}
        />
      </div>
      <div style={styles.outlet}>
        <Header
          headerName={headerName}
          setOpenManualEntry={setOpenManualEntry}
        />
        <div style={styles.outletContainer}>
          <Outlet
            context={{
              setHeaderName,
              openManualEntry,
              setOpenManualEntry,
              openMyProfile,
              setOpenMyProfile,
            }}
          />
        </div>
      </div>
      <RightPannel
        componentToPassDown={
          <AddGlucoseLevel
            navigation={navigate}
            route={{
              params: openManualEntry || {},
            }}
            onClose={() => setOpenManualEntry(false)}
          />
        }
        open={openManualEntry}
        onClose={() => setOpenManualEntry(false)}
      />
    </div>
  );
};

export default Layout;
